export default {
  version: '1.9.6',
  api: 'https://api.eyeson.team',
  allowSafariSFU: true,
  screencapture: true,
  verbose: true,
  vbgScriptPath: 'vendor/tflite/',
  hdCamera: true
};
